import { createAction, props } from '@ngrx/store';
import { WorkflowRestrictions } from './workflow-restrictions.model';


// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record workflow restrictions'
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record workflow restrictions success', 
    props<{ singleData: WorkflowRestrictions }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record workflow restrictions failure', 
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record workflow restrictions',
    props<{ updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record workflow restrictions success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record workflow restrictions failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state workflow restrictions',
);